import { Check, CheckCheck, Clock, AlertCircle, FileText, Image, Video, Music, Sticker } from 'lucide-react'
import { Message } from '@/hooks/useConversationMessages'

export function getMediaIcon(type: string) {
  switch (type) {
    case 'image': return <Image className="h-4 w-4" />
    case 'video': return <Video className="h-4 w-4" />
    case 'audio': return <Music className="h-4 w-4" />
    case 'sticker': return <Sticker className="h-4 w-4" />
    default: return <FileText className="h-4 w-4" />
  }
}

export function getMessageStatusIcon(message: Message) {
  if (message.is_inbound) return null

  const status = message.status?.toLowerCase()

  if (status === 'failed') {
    return <AlertCircle className="h-3 w-3 text-red-500" />
  }

  switch (status) {
    case 'sent':
      return <Check className="h-3 w-3 text-muted-foreground" />
    case 'delivered':
      return <CheckCheck className="h-3 w-3 text-muted-foreground" />
    case 'read':
      return <CheckCheck className="h-3 w-3 text-blue-500" />
    default:
      return <Clock className="h-3 w-3 text-muted-foreground" />
  }
}

